const OVERLAY_ID = 'wf-transition-overlay'
const STYLE_ID = 'wf-transition-overlay-style'
const FADE_DURATION_MS = 150

let hideTimer: number | undefined
let activeTransitionCount = 0

const ensureStyleTag = (): void => {
  if (document.getElementById(STYLE_ID)) return
  const style = document.createElement('style')
  style.id = STYLE_ID
  style.textContent = '@keyframes wf-spin{to{transform:rotate(360deg)}}'
  document.head.appendChild(style)
}

const clearPendingHide = (): void => {
  if (hideTimer) {
    window.clearTimeout(hideTimer)
    hideTimer = undefined
  }
}

export function showTransitionOverlay(): void {
  clearPendingHide()

  const existingOverlay = document.getElementById(OVERLAY_ID) as HTMLDivElement | null
  if (existingOverlay) {
    existingOverlay.style.opacity = '1'
    return
  }

  ensureStyleTag()

  const overlay = document.createElement('div')
  overlay.id = OVERLAY_ID
  overlay.style.cssText =
    'position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:#fff;z-index:99999;opacity:0;transition:opacity 150ms ease;'

  const spinner = document.createElement('div')
  spinner.style.cssText =
    'width:40px;height:40px;border:3.6px solid #e0e0e0;border-top-color:#1C1C1C;border-radius:50%;animation:wf-spin .8s linear infinite;'

  overlay.append(spinner)
  document.body.appendChild(overlay)
  requestAnimationFrame(() => {
    overlay.style.opacity = '1'
  })
}

export function hideTransitionOverlay(options?: { force?: boolean }): void {
  const overlay = document.getElementById(OVERLAY_ID) as HTMLDivElement | null
  if (!overlay) return

  const isForceHide = Boolean(options?.force)
  if (isForceHide) {
    activeTransitionCount = 0
  } else {
    if (activeTransitionCount > 0) {
      activeTransitionCount -= 1
    }
    if (activeTransitionCount > 0) {
      return
    }
  }

  clearPendingHide()
  overlay.style.opacity = '0'
  hideTimer = window.setTimeout(() => {
    const currentOverlay = document.getElementById(OVERLAY_ID)
    if (!currentOverlay) return
    if ((currentOverlay as HTMLDivElement).style.opacity !== '0') return
    currentOverlay.remove()
    hideTimer = undefined
  }, FADE_DURATION_MS)
}

export async function withTransitionOverlay<T>(task: () => Promise<T>): Promise<T> {
  activeTransitionCount += 1
  showTransitionOverlay()
  try {
    return await task()
  } finally {
    hideTransitionOverlay()
  }
}
